// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"f59095f7","73":"dd327354","126":"e85e0816","167":"72cdc732","266":"dd327354","317":"dd327354","379":"dd327354","464":"f59095f7","724":"f59095f7","869":"dd327354"}[chunkId] + ".chunk.css";
};